<template>
  <div class="global-flow-error--outer-container gds-flex-container">
    <div class="global-flow-error--inner-container">
      <img v-if="!img" class="maintenance-graphic" src="/wp-content/themes/gmptwentynineteen/assets/images/maintenance-error.svg" />
      <img v-if="img" class="maintenance-graphic" :src="img" />
      <div class="maintenance-message maintenance-message--main gds-space-stack-m">
        {{name}}
        <template v-if="state === 'maintenance'">is temporarily disabled while we perform routine maintenance. Please try again later.</template>
        <template v-if="state === 'error'">
          is not available at the moment.
          <br />Please try again later.
        </template>
        <template v-if="state === 'unavailable'">is not available for this account.</template>
      </div>
      <div v-if="phonetext" class="maintenance-message--phone gds-space-stack-l">
        {{phonetext}}
        <span class="gds-nobreak">{{GMPPhoneNumber}}.</span>
      </div>
      <button v-if="closepath" @click="ReturnToSender(closepath)" class="global-flow-error__button gds-button">Close</button>
    </div>
  </div>
</template>

<script>
import { ReturnToSender } from "../../utilities";
import { GMPPhoneNumber } from '../../environment';
export default {
  name: "FlowError",
  props: [
    /** Name of the component/section that is unavailable */
    "name",
    /** State of the component: maintenance, unavailable (for this account), error */
    "state",
    /** If present, add a "call us" message with this text */
    "phonetext",
    /** If present, add a close button to exit the flow. Populate with the flow path, just like ReturnToSender */
    "closepath",
    /** If present, use a custom image rather than crossed tools */
    "img",
  ],
  data() {
    return {
      ReturnToSender,
      GMPPhoneNumber,
    };
  },
};
</script>

<style scoped>
</style>